<script>
    import imagesLoaded from 'vue-images-loaded'

    export default {
        directives: {
            imagesLoaded
        },
        mounted: function () {
            this.calcLayout()
        },
        methods: {
            imagesloaded: function () {
                this.calcLayout()
            },
            calcLayout: function () {
                if (this.$el.getBoundingClientRect().width > 1300) {
                    setTimeout(this.calcLayout, 1000)
                    return false
                }
                // reset fixed text heights
                Array.from(this.$el.querySelectorAll('.item .sv-text')).forEach(function (item) {
                    item.style.height = ''
                })

                // set equal height for the bottom text elements in the 4 layout grid to
                // bring the images on the horizontal orientation
                var layout4Elements = Array.from(this.$el.querySelectorAll('.layout_4_smlg, .layout_4_lgsm'))
                layout4Elements.forEach(
                    function (item) {
                        var textItems = item.querySelectorAll('.is-flex-direction-column .item.second [class*="sv-text"]')
                        if (textItems.length === 2) {
                            var rect0 = textItems[0].getBoundingClientRect()
                            var rect1 = textItems[1].getBoundingClientRect()
                            if (rect0.height > rect1.height) {
                                textItems[1].style.height = (rect0.height) + 'px'
                            } else if (rect0.height < rect1.height) {
                                textItems[0].style.height = (rect1.height) + 'px'
                            }
                        }
                    }
                )
            }
        }
    }
</script>




// WEBPACK FOOTER //
// sv_cms/static/assets/vue/components/svgridlayout.vue